import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import {
  checkUpdates,
  dealerfilials,
  fetchCities,
  fetchDealerBranches,
  fetchDealers,
  fetchOneDealer,
  fetchOrderedDealers,
  waitHandcraftOrdeStateCompleted,
} from "../../api/thunks";
import { DealerSliceState, IDealer } from "../types";
import { applyDealerFilters } from "../lib/applyDealerFilters";

export const addListExtraReducers = (
  builder: ActionReducerMapBuilder<DealerSliceState>,
) => {
  builder.addCase(fetchDealers.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });
  builder.addCase(fetchDealers.fulfilled, (state, action) => {
    const dealers: IDealer[] = action.payload.items;
    state.error = null;
    state.isLoading = false;

    state.dealersListForFilter = dealers;
    state.dealersList = applyDealerFilters(state);
  });
  builder.addCase(fetchDealers.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });

  builder.addCase(fetchDealerBranches.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });
  builder.addCase(fetchDealerBranches.fulfilled, (state, action) => {
    const dealers: IDealer[] = action.payload.items;
    state.error = null;
    state.isLoading = false;
    state.branchesList = dealers;
    state.currentDealerBranchesForFilter = dealers;
    state.currentMainDealer = dealers.find((d) => d.isMain);
  });
  builder.addCase(fetchDealerBranches.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });

  builder.addCase(fetchOneDealer.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });
  builder.addCase(
    fetchOneDealer.fulfilled,
    (state, action: PayloadAction<IDealer>) => {
      state.error = null;
      state.isLoading = false;
      state.currentDealer = action.payload;
      state.currentDealerUsers = action.payload.users;
      state.currentDealerUsersForFilter = action.payload.users;
    },
  );
  builder.addCase(fetchOneDealer.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });

  builder.addCase(checkUpdates.pending, (state) => {
    state.error = null;
  });
  builder.addCase(checkUpdates.fulfilled, (state, action) => {
    state.hasUpdates = !!action.payload?.items?.length;
    state.error = null;
  });
  builder.addCase(checkUpdates.rejected, (state, action) => {
    state.error = action.payload;
  });

  builder.addCase(dealerfilials.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });
  builder.addCase(dealerfilials.fulfilled, (state, action) => {
    state.isLoading = false;
    state.error = null;

    state.filials = action.payload.length ? action.payload[0].fillials : [];
    if (action.payload[0]) {
      const { id, shortName, status, statusName } = action.payload[0];
      state.mainFilial = {
        id,
        shortName,
        status,
        statusName,
      };
    }
  });
  builder.addCase(dealerfilials.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });

  builder.addCase(fetchCities.pending, (state) => {
    state.error = null;
  });
  builder.addCase(fetchCities.fulfilled, (state, action) => {
    state.cities = action.payload;
    state.error = null;
  });
  builder.addCase(fetchCities.rejected, (state, action) => {
    state.error = action.payload;
  });

  builder.addCase(fetchOrderedDealers.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });
  builder.addCase(fetchOrderedDealers.fulfilled, (state, action) => {
    state.error = null;
    state.isLoading = false;
    state.orderedDealers = action.payload?.items;
  });
  builder.addCase(fetchOrderedDealers.rejected, (state, action) => {
    state.error = action.payload;
    state.isLoading = false;
  });

  builder.addCase(waitHandcraftOrdeStateCompleted.pending, (state) => {
    state.error = null;
    state.isHandcraftOrderLoading = true;
  });
  builder.addCase(waitHandcraftOrdeStateCompleted.fulfilled, (state) => {
    state.isHandcraftOrderLoading = false;
  });
  builder.addCase(waitHandcraftOrdeStateCompleted.rejected, (state, action) => {
    state.isHandcraftOrderLoading = false;
    // abort в cleanup useEffect тоже попадает в rejected — это не ошибка
    if (action.meta.aborted) return;
    state.error = action.payload;
  });
};
